import Modal from "antd/lib/modal/Modal";
import React, { createContext, useContext, useState } from "react";
import { Button, DatePicker, Space, Form, notification } from "antd";
import EbendoDailyProductionStore from "../store/ebendodailyproductionstore";
import { observer } from "mobx-react-lite";
import { ProgressIndicator } from "@fluentui/react";
const { RangePicker } = DatePicker;
const EbendoStoreCtx = createContext(EbendoDailyProductionStore);
export const EbendoWellAllocationExport = observer(() => {
  const ebendoDailyProductionStore = useContext(EbendoStoreCtx);
  const [podExportDate, setPodExportDate] = useState(null);
  return (
    <Modal
      visible={ebendoDailyProductionStore.showWellAllocationExportDialog}
      title={"Select Ebendo Productions/Well Allocations Export Date Range"}
      onCancel={() => {
        ebendoDailyProductionStore.showWellAllocationExportDialog = false;
      }}
      centered
      footer={
        <Space>
          {ebendoDailyProductionStore.isExporting && (
            <ProgressIndicator
              description="exporting, please wait..."
              styles={{ root: { width: "200px", textAlign: "left" } }}
            />
          )}
          <Button
            type="link"
            onClick={() => {
              ebendoDailyProductionStore.showWellAllocationExportDialog = false;
            }}
          >
            Close
          </Button>
          <Button
            type="primary"
            loading={ebendoDailyProductionStore.isExporting}
            disabled={podExportDate === null}
            onClick={async () => {
              try {
                ebendoDailyProductionStore.exportWellAllocation(podExportDate);

                console.log("podExportDate", podExportDate);
              } catch (error) {
                notification.error({
                  message: "SPARS Feedback",
                  description: error.message,
                });
              }
            }}
          >
            Export
          </Button>
        </Space>
      }
    >
      <Form layout="vertical" name="basic">
        <Form.Item>
          <RangePicker
            placeholder={[
              "Refer (Production) Start Date",
              "Refer (Production) End Date",
            ]}
            style={{ width: "95%" }}
            onChange={(dateObj, dateStringArr) => {
              setPodExportDate(dateObj);
            }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
});

